import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  InputAdornment,
  IconButton,
  Menu,
  Pagination,
  Tooltip,
  Badge,
  Fab
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  FilterList as FilterListIcon,
  Sort as SortIcon,
  MoreVert as MoreVertIcon,
  Priority as PriorityIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Schedule as ScheduleIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Message as MessageIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Refresh as RefreshIcon,
  Assignment as AssignmentIcon,
  History as HistoryIcon,
  AttachFile as AttachFileIcon,
  Send as SendIcon,
  Edit as EditIcon
} from '@mui/icons-material';

const SupportTickets = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [priorityFilter, setPriorityFilter] = useState('all');
  const [assigneeFilter, setAssigneeFilter] = useState('all');
  const [sortBy, setSortBy] = useState('created_desc');
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketDetailOpen, setTicketDetailOpen] = useState(false);
  const [createTicketOpen, setCreateTicketOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTicketForAction, setSelectedTicketForAction] = useState(null);

  // Mock ticket data
  const tickets = [
    {
      id: 'T-2024-001',
      title: 'অর্ডার ক্যান্সেল করতে সমস্যা',
      customer: 'রহিম উদ্দিন',
      customerPhone: '01712345678',
      customerEmail: 'rahim@example.com',
      status: 'নতুন',
      priority: 'উচ্চ',
      category: 'অর্ডার সম্পর্কিত',
      assignee: 'অনির্ধারিত',
      created: '২০২৪-০১-১৫ ১০:৩০ AM',
      updated: '২০২৪-০১-১৫ ১০:৩০ AM',
      description: 'গ্রাহক তার অর্ডার ক্যান্সেল করতে পারছেন না। অর্ডার নম্বর: ORD-2024-156',
      messages: [
        {
          id: 1,
          sender: 'রহিম উদ্দিন',
          type: 'customer',
          message: 'আমি আমার অর্ডার ক্যান্সেল করতে পারছি না। সাহায্য প্রয়োজন।',
          timestamp: '২০২৪-০১-১৫ ১০:৩০ AM'
        }
      ]
    },
    {
      id: 'T-2024-002',
      title: 'ডেলিভারি বিলম্ব',
      customer: 'ফাতেমা খাতুন',
      customerPhone: '01898765432',
      customerEmail: 'fatema@example.com',
      status: 'প্রসেসিং',
      priority: 'মাধ্যম',
      category: 'ডেলিভারি সমস্যা',
      assignee: 'সালমা বেগম',
      created: '২০২৪-০১-১৪ ০২:১৫ PM',
      updated: '২০২৪-০১-১৫ ০৯:২০ AM',
      description: 'অর্ডার ডেলিভারি হতে দেরি হচ্ছে। প্রত্যাশিত সময় অতিক্রম করেছে।',
      messages: [
        {
          id: 1,
          sender: 'ফাতেমা খাতুন',
          type: 'customer',
          message: 'আমার অর্ডার এখনো পৌঁছায়নি। কবে পাব?',
          timestamp: '২০২৪-০১-১৪ ০২:১৫ PM'
        },
        {
          id: 2,
          sender: 'সালমা বেগম',
          type: 'agent',
          message: 'আপনার অর্ডারটি ট্র্যাক করা হচ্ছে। আজ সন্ধ্যার মধ্যে ডেলিভারি হবে।',
          timestamp: '২০২৪-০১-১৫ ০৯:২০ AM'
        }
      ]
    },
    {
      id: 'T-2024-003',
      title: 'পেমেন্ট রিফান্ড সমস্যা',
      customer: 'করিম মিয়া',
      customerPhone: '01919876543',
      customerEmail: 'karim@example.com',
      status: 'সমাধানকৃত',
      priority: 'উচ্চ',
      category: 'পেমেন্ট ইস্যু',
      assignee: 'রহিম উদ্দিন',
      created: '২০২৪-০১-১৩ ১১:৪৫ AM',
      updated: '২০২৪-০১-১৪ ০৪:৩০ PM',
      description: 'ক্যান্সেল করা অর্ডারের পেমেন্ট রিফান্ড পাননি।',
      messages: [
        {
          id: 1,
          sender: 'করিম মিয়া',
          type: 'customer',
          message: 'আমার রিফান্ড কোথায়? ৩ দিন হয়ে গেছে।',
          timestamp: '২০২৪-০১-১৩ ১১:৪৫ AM'
        },
        {
          id: 2,
          sender: 'রহিম উদ্দিন',
          type: 'agent',
          message: 'আপনার রিফান্ড প্রসেস করা হয়েছে। ২-৩ কার্যদিবসে পাবেন।',
          timestamp: '২০২৪-০১-১৪ ০৪:৩০ PM'
        }
      ]
    },
    {
      id: 'T-2024-004',
      title: 'ভুল পণ্য ডেলিভারি',
      customer: 'সাকিনা খাতুন',
      customerPhone: '01612345678',
      customerEmail: 'sakina@example.com',
      status: 'অপেক্ষমান',
      priority: 'মাধ্যম',
      category: 'প্রোডাক্ট সমস্যা',
      assignee: 'ফাতেমা খাতুন',
      created: '২০২৪-০১-১৫ ০৮:২০ AM',
      updated: '২০২৪-০১-১৫ ১০:১০ AM',
      description: 'অর্ডার করা পণ্যের পরিবর্তে ভিন্ন পণ্য এসেছে।',
      messages: [
        {
          id: 1,
          sender: 'সাকিনা খাতুন',
          type: 'customer',
          message: 'আমি চাল অর্ডার করেছিলাম কিন্তু ডাল এসেছে।',
          timestamp: '২০২৪-০১-১৫ ০৮:২০ AM'
        }
      ]
    },
    {
      id: 'T-2024-005',
      title: 'অ্যাকাউন্ট লগইন সমস্যা',
      customer: 'আব্দুল হক',
      customerPhone: '01512345678',
      customerEmail: 'abdul@example.com',
      status: 'বন্ধ',
      priority: 'নিম্ন',
      category: 'অ্যাকাউন্ট সমস্যা',
      assignee: 'করিম মিয়া',
      created: '২০২৪-০১-১২ ০৩:১০ PM',
      updated: '২০২৪-০১-১৩ ১১:৫৫ AM',
      description: 'গ্রাহক তার অ্যাকাউন্টে লগইন করতে পারছেন না।',
      messages: [
        {
          id: 1,
          sender: 'আব্দুল হক',
          type: 'customer',
          message: 'আমি পাসওয়ার্ড ভুলে গেছি। রিসেট করতে পারছি না।',
          timestamp: '২০২৪-০১-১২ ০৩:১০ PM'
        },
        {
          id: 2,
          sender: 'করিম মিয়া',
          type: 'agent',
          message: 'আপনার পাসওয়ার্ড রিসেট লিংক পাঠানো হয়েছে।',
          timestamp: '২০২৪-০১-১৩ ১১:৫৫ AM'
        }
      ]
    }
  ];

  const agents = [
    'রহিম উদ্দিন',
    'ফাতেমা খাতুন', 
    'সালমা বেগম',
    'করিম মিয়া',
    'আব্দুল হক'
  ];

  const statuses = ['নতুন', 'প্রসেসিং', 'অপেক্ষমান', 'সমাধানকৃত', 'বন্ধ'];
  const priorities = ['নিম্ন', 'মাধ্যম', 'উচ্চ', 'জরুরি'];
  const categories = ['অর্ডার সম্পর্কিত', 'ডেলিভারি সমস্যা', 'পেমেন্ট ইস্যু', 'প্রোডাক্ট সমস্যা', 'অ্যাকাউন্ট সমস্যা'];

  const getStatusColor = (status) => {
    switch (status) {
      case 'নতুন': return 'primary';
      case 'প্রসেসিং': return 'warning';
      case 'অপেক্ষমান': return 'info';
      case 'সমাধানকৃত': return 'success';
      case 'বন্ধ': return 'default';
      default: return 'default';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'নিম্ন': return 'success';
      case 'মাধ্যম': return 'warning';
      case 'উচ্চ': return 'error';
      case 'জরুরি': return 'error';
      default: return 'default';
    }
  };

  const handleTicketClick = (ticket) => {
    setSelectedTicket(ticket);
    setTicketDetailOpen(true);
  };

  const handleActionClick = (event, ticket) => {
    setAnchorEl(event.currentTarget);
    setSelectedTicketForAction(ticket);
  };

  const handleCloseActionMenu = () => {
    setAnchorEl(null);
    setSelectedTicketForAction(null);
  };

  const filteredTickets = tickets.filter(ticket => {
    if (currentTab === 0 && statusFilter !== 'all' && ticket.status !== statusFilter) return false;
    if (currentTab === 1 && ticket.assignee === 'অনির্ধারিত') return false;
    if (currentTab === 2 && ticket.status === 'সমাধানকৃত') return false;
    if (priorityFilter !== 'all' && ticket.priority !== priorityFilter) return false;
    if (assigneeFilter !== 'all' && ticket.assignee !== assigneeFilter) return false;
    if (searchQuery && !ticket.title.toLowerCase().includes(searchQuery.toLowerCase()) && 
        !ticket.customer.toLowerCase().includes(searchQuery.toLowerCase()) &&
        !ticket.id.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    return true;
  });

  const getTicketCounts = () => {
    return {
      all: tickets.length,
      new: tickets.filter(t => t.status === 'নতুন').length,
      assigned: tickets.filter(t => t.assignee !== 'অনির্ধারিত').length,
      open: tickets.filter(t => !['সমাধানকৃত', 'বন্ধ'].includes(t.status)).length
    };
  };

  const counts = getTicketCounts();

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" component="h1" gutterBottom sx={{ 
            background: 'linear-gradient(45deg, #5e35b1 30%, #1e88e5 90%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold'
          }}>
            সাপোর্ট টিকেট
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            টিকেট ব্যবস্থাপনা এবং গ্রাহক সেবা
          </Typography>
        </Box>
        
        <Button 
          variant="contained" 
          startIcon={<AddIcon />}
          onClick={() => setCreateTicketOpen(true)}
          sx={{ 
            background: 'linear-gradient(45deg, #5e35b1 30%, #1e88e5 90%)',
            color: 'white'
          }}
        >
          নতুন টিকেট
        </Button>
      </Box>

      {/* Quick Stats */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" color="primary" sx={{ fontWeight: 'bold' }}>
                {counts.all}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                মোট টিকেট
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" color="warning.main" sx={{ fontWeight: 'bold' }}>
                {counts.new}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                নতুন টিকেট
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" color="info.main" sx={{ fontWeight: 'bold' }}>
                {counts.assigned}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                নির্ধারিত টিকেট
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent sx={{ textAlign: 'center' }}>
              <Typography variant="h4" color="success.main" sx={{ fontWeight: 'bold' }}>
                {counts.open}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                খোলা টিকেট
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Search and Filters */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              placeholder="টিকেট খুঁজুন..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>স্ট্যাটাস</InputLabel>
              <Select
                value={statusFilter}
                label="স্ট্যাটাস"
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="all">সব</MenuItem>
                {statuses.map((status) => (
                  <MenuItem key={status} value={status}>{status}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>অগ্রাধিকার</InputLabel>
              <Select
                value={priorityFilter}
                label="অগ্রাধিকার"
                onChange={(e) => setPriorityFilter(e.target.value)}
              >
                <MenuItem value="all">সব</MenuItem>
                {priorities.map((priority) => (
                  <MenuItem key={priority} value={priority}>{priority}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>নির্ধারিত</InputLabel>
              <Select
                value={assigneeFilter}
                label="নির্ধারিত"
                onChange={(e) => setAssigneeFilter(e.target.value)}
              >
                <MenuItem value="all">সব</MenuItem>
                <MenuItem value="অনির্ধারিত">অনির্ধারিত</MenuItem>
                {agents.map((agent) => (
                  <MenuItem key={agent} value={agent}>{agent}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth>
              <InputLabel>সাজান</InputLabel>
              <Select
                value={sortBy}
                label="সাজান"
                onChange={(e) => setSortBy(e.target.value)}
              >
                <MenuItem value="created_desc">নতুন আগে</MenuItem>
                <MenuItem value="created_asc">পুরাতন আগে</MenuItem>
                <MenuItem value="priority_desc">অগ্রাধিকার উচ্চ</MenuItem>
                <MenuItem value="status">স্ট্যাটাস অনুযায়ী</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Ticket Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs 
          value={currentTab} 
          onChange={(e, newValue) => setCurrentTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab 
            label={
              <Badge badgeContent={counts.all} color="primary">
                সব টিকেট
              </Badge>
            } 
          />
          <Tab 
            label={
              <Badge badgeContent={counts.assigned} color="info">
                নির্ধারিত টিকেট
              </Badge>
            } 
          />
          <Tab 
            label={
              <Badge badgeContent={counts.open} color="warning">
                খোলা টিকেট
              </Badge>
            } 
          />
        </Tabs>
      </Paper>

      {/* Tickets Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>টিকেট ID</TableCell>
                <TableCell>শিরোনাম</TableCell>
                <TableCell>গ্রাহক</TableCell>
                <TableCell>স্ট্যাটাস</TableCell>
                <TableCell>অগ্রাধিকার</TableCell>
                <TableCell>বিভাগ</TableCell>
                <TableCell>নির্ধারিত</TableCell>
                <TableCell>তৈরি</TableCell>
                <TableCell>কার্যক্রম</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredTickets.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((ticket) => (
                <TableRow 
                  key={ticket.id} 
                  hover 
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleTicketClick(ticket)}
                >
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, color: 'primary.main' }}>
                      {ticket.id}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {ticket.title}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar sx={{ mr: 1, width: 32, height: 32, bgcolor: '#5e35b1' }}>
                        {ticket.customer.charAt(0)}
                      </Avatar>
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                          {ticket.customer}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {ticket.customerPhone}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={ticket.status} 
                      color={getStatusColor(ticket.status)} 
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Chip 
                      label={ticket.priority} 
                      color={getPriorityColor(ticket.priority)} 
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {ticket.category}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    {ticket.assignee === 'অনির্ধারিত' ? (
                      <Chip label="অনির্ধারিত" color="default" size="small" />
                    ) : (
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar sx={{ mr: 1, width: 24, height: 24, bgcolor: '#1976d2' }}>
                          {ticket.assignee.charAt(0)}
                        </Avatar>
                        <Typography variant="caption">
                          {ticket.assignee}
                        </Typography>
                      </Box>
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" color="text.secondary">
                      {ticket.created}
                    </Typography>
                  </TableCell>
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <IconButton 
                      size="small"
                      onClick={(e) => handleActionClick(e, ticket)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* Pagination */}
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <Pagination 
            count={Math.ceil(filteredTickets.length / rowsPerPage)} 
            page={page} 
            onChange={(e, newPage) => setPage(newPage)}
            color="primary"
          />
        </Box>
      </Paper>

      {/* Action Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseActionMenu}
      >
        <MenuItem onClick={handleCloseActionMenu}>
          <AssignmentIcon sx={{ mr: 1 }} />
          নির্ধারণ করুন
        </MenuItem>
        <MenuItem onClick={handleCloseActionMenu}>
          <EditIcon sx={{ mr: 1 }} />
          সম্পাদনা করুন
        </MenuItem>
        <MenuItem onClick={handleCloseActionMenu}>
          <CheckCircleIcon sx={{ mr: 1 }} />
          সমাধান করুন
        </MenuItem>
        <MenuItem onClick={handleCloseActionMenu}>
          <CancelIcon sx={{ mr: 1 }} />
          বন্ধ করুন
        </MenuItem>
      </Menu>

      {/* Ticket Detail Dialog */}
      <Dialog open={ticketDetailOpen} onClose={() => setTicketDetailOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ 
          background: 'linear-gradient(45deg, #5e35b1 30%, #1e88e5 90%)',
          color: 'white'
        }}>
          টিকেট বিস্তারিত - {selectedTicket?.id}
        </DialogTitle>
        <DialogContent>
          {selectedTicket && (
            <Box sx={{ mt: 2 }}>
              {/* Ticket Info */}
              <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={8}>
                  <Typography variant="h6" gutterBottom>
                    {selectedTicket.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {selectedTicket.description}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                    <Chip label={selectedTicket.status} color={getStatusColor(selectedTicket.status)} size="small" />
                    <Chip label={selectedTicket.priority} color={getPriorityColor(selectedTicket.priority)} size="small" variant="outlined" />
                    <Chip label={selectedTicket.category} size="small" />
                  </Box>
                </Grid>
                
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2, bgcolor: '#f8f9fa' }}>
                    <Typography variant="subtitle2" gutterBottom>গ্রাহক তথ্য</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <PersonIcon sx={{ mr: 1, fontSize: '1rem' }} />
                      <Typography variant="body2">{selectedTicket.customer}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                      <PhoneIcon sx={{ mr: 1, fontSize: '1rem' }} />
                      <Typography variant="body2">{selectedTicket.customerPhone}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <EmailIcon sx={{ mr: 1, fontSize: '1rem' }} />
                      <Typography variant="body2">{selectedTicket.customerEmail}</Typography>
                    </Box>
                    
                    <Typography variant="subtitle2" gutterBottom>টিকেট তথ্য</Typography>
                    <Typography variant="caption" color="text.secondary">
                      তৈরি: {selectedTicket.created}
                    </Typography><br/>
                    <Typography variant="caption" color="text.secondary">
                      আপডেট: {selectedTicket.updated}
                    </Typography><br/>
                    <Typography variant="caption" color="text.secondary">
                      নির্ধারিত: {selectedTicket.assignee}
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
              
              {/* Messages */}
              <Paper sx={{ p: 2, maxHeight: 300, overflow: 'auto' }}>
                <Typography variant="h6" gutterBottom>
                  কথোপকথন
                </Typography>
                {selectedTicket.messages.map((message) => (
                  <Box 
                    key={message.id} 
                    sx={{ 
                      mb: 2, 
                      p: 2, 
                      bgcolor: message.type === 'customer' ? '#e3f2fd' : '#f3e5f5',
                      borderRadius: 2,
                      borderLeft: `4px solid ${message.type === 'customer' ? '#2196f3' : '#9c27b0'}`
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {message.sender}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {message.timestamp}
                      </Typography>
                    </Box>
                    <Typography variant="body2">
                      {message.message}
                    </Typography>
                  </Box>
                ))}
              </Paper>
              
              {/* Reply Box */}
              <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                <TextField
                  fullWidth
                  placeholder="উত্তর লিখুন..."
                  multiline
                  rows={3}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Button variant="contained" startIcon={<SendIcon />} size="small">
                    পাঠান
                  </Button>
                  <Button variant="outlined" startIcon={<AttachFileIcon />} size="small">
                    ফাইল
                  </Button>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTicketDetailOpen(false)}>বন্ধ করুন</Button>
          <Button variant="contained" startIcon={<CheckCircleIcon />}>
            সমাধান করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Create Ticket Dialog */}
      <Dialog open={createTicketOpen} onClose={() => setCreateTicketOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ 
          background: 'linear-gradient(45deg, #5e35b1 30%, #1e88e5 90%)',
          color: 'white'
        }}>
          নতুন টিকেট তৈরি করুন
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="শিরোনাম"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="গ্রাহকের নাম"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="ফোন নম্বর"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>অগ্রাধিকার</InputLabel>
                <Select label="অগ্রাধিকার">
                  {priorities.map((priority) => (
                    <MenuItem key={priority} value={priority}>{priority}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>বিভাগ</InputLabel>
                <Select label="বিভাগ">
                  {categories.map((category) => (
                    <MenuItem key={category} value={category}>{category}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="বিস্তারিত বর্ণনা"
                variant="outlined"
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateTicketOpen(false)}>বাতিল</Button>
          <Button 
            variant="contained" 
            onClick={() => {
              alert('টিকেট তৈরি হয়েছে!');
              setCreateTicketOpen(false);
            }}
          >
            তৈরি করুন
          </Button>
        </DialogActions>
      </Dialog>

      {/* Floating Action Button */}
      <Fab 
        color="primary" 
        aria-label="add"
        sx={{ 
          position: 'fixed', 
          bottom: 16, 
          right: 16,
          background: 'linear-gradient(45deg, #5e35b1 30%, #1e88e5 90%)'
        }}
        onClick={() => setCreateTicketOpen(true)}
      >
        <AddIcon />
      </Fab>
    </Box>
  );
};

export default SupportTickets; 